import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { businessLogic } from '../../lib/constants';

const getFooterColumns = (t) => [
  // Columnas compensadas (2026-10-17): 8 · 7 · 8 · 8 enlaces.
  {
    key: "company",
    title: t("home_footer_title_company"),
    links: [
      { label: t("home_footer_company_about_us"), to: "/about" },
      { label: t("home_footer_company_services"), to: "/home#services" },
      { label: t("home_footer_company_blog"), to: "/blog" },
      { label: t("home_footer_company_contactus"), to: "/contact#contact" },
      // OCULTA 2026-10-28: { label: "Team", to: "/team" },
      { label: t("home_footer_company_jobs"), to: "/jobs" },
      { label: t("home_footer_company_press"), to: "/press" },
      { label: "Roadmap", to: "/roadmap" },
    ],
  },
  {
    key: "resources",
    title: t("home_footer_title_resources"),
    links: [
      // El kit de IA ya no va directo: /resources lista los kits, webinars, etc. (2026-10-17).
      // { label: t("aikit_nav_label"), to: "/resources/ai-kit" },
      // Landing del vertical de seguimiento comercial (2026-10-26): enlace interno para posicionarla.
      { label: t("home_footer_sales_followup"), to: t("home_footer_sales_followup_to") },
      { label: t("home_footer_consulting"), to: t("home_footer_consulting_to") },
      { label: t("home_footer_resources_hub"), to: "/resources" },
      { label: t("home_footer_platform_docs"), to: "/documentation" },
      { label: t("home_footer_resources_faqs"), to: "/faq" },
      { label: t("home_footer_platform_changelog"), to: "/changelog" },
      { label: "Customer Portal", to: "/customer-portal" },
      { label: t("footer_privacy"), to: "/privacy" },
      { label: t("footer_terms"), to: "/terms" },
      // OCULTOS 2026-10-17, PENDIENTES DE REVISAR Y REABRIR: paginas sin contenido trabajado.
      // Las rutas siguen vivas en App.js; solo se quitan del pie (y llevan noindex).
      // { label: t("home_footer_resources_guidelines"), to: "/guidelines" },
      // { label: t("home_footer_resources_operators"), to: "/operators" },
      // { label: t("home_footer_platform_partnerships"), to: "/partnerships" },
      // { label: t("home_footer_resources_reviews"), to: "/reviews" },
    ],
  },
  {
    key: "platform",
    title: t("home_footer_title_usecases"),
    links: [
      { label: t("home_footer_platform_core"), to: "/platform" },
      { label: t("home_footer_platform_features"), to: "/playbooks" },
      { label: t("home_footer_platform_pricing"), to: "/pricing" },
      { label: t("home_footer_platform_demo"), to: "/demo" },
      { label: t("home_footer_platform_playbook_demo"), to: "/playbook-demo" },
      { label: t("gs_page_title"), to: "/get-started" },
      { label: "How It Works", to: "/how-it-works" },
      { label: "Product Tour", to: "/product-tour" },
    ],
  },
  {
    key: "learn",
    title: t("home_footer_title_contact"),
    links: [
      { label: businessLogic.emailBase, href: `mailto:${businessLogic.emailBase}` },
      { label: businessLogic.contactEmail, href: `mailto:${businessLogic.contactEmail}` },
      { label: t("home_footer_contact_agencies"), href: "/agencies", external: true },
      { label: t("home_footer_contact_partners"), href: "/partners", external: true },
      { label: t("home_footer_contact_product"), href: "/product", external: true },
      { label: t("home_footer_contact_scale"), href: "/scale", external: true },
      { label: t("home_footer_contact_explore"), href: "/explore", external: true },
      { label: t("home_footer_contact_affiliates"), href: "/affiliates", external: true },
    ],
  },
];

const FooterColumns = ({
  columnClasses = [],
  widgetClassName = "footer__widget mb-45",
  titleClassName = "",
  linksClassName = "footer__links",
}) => {
  const { t } = useTranslation();
  const columns = getFooterColumns(t);

  const resolveColClass = (index) => {
    if (Array.isArray(columnClasses)) {
      return columnClasses[index] || columnClasses[columnClasses.length - 1] || "";
    }
    return columnClasses || "";
  };

  const renderLink = (link) => {
    if (link.to) {
      if (link.to === "/blog" || link.to.startsWith("/blog/")) {
        return <a href={link.to}>{link.label}</a>;
      }
      return <Link to={link.to}>{link.label}</Link>;
    }

    const isExternal = link.external === true;
    const isMail = link.href && link.href.startsWith("mailto:");
    const target = isExternal && !isMail ? "_blank" : undefined;
    const rel = isExternal && !isMail ? "noreferrer" : undefined;

    return (
      <a href={link.href} target={target} rel={rel}>
        {link.label}
      </a>
    );
  };

  return (
    <>
      {columns.map((column, index) => (
        <div className={resolveColClass(index)} key={column.key}>
          <div className={widgetClassName}>
            <div className={`footer__widget-title${titleClassName ? ` ${titleClassName}` : ""}`}>
              <h4>{column.title}</h4>
            </div>
            <div className="footer__widget-content">
              <div className={linksClassName}>
                <ul>
                  {column.links.map((link, idx) => (
                    <li key={`${column.key}-${idx}`}>{renderLink(link)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FooterColumns;
